import {useRef} from 'react'
import {Language} from 'yougile-lang'
import {Sync} from '@client/sync'
import {useForceUpdate, useSyncEvent} from '@containers/hooks'
import {globals} from './globals-base'

export const useLang = (): Language => {
  const prevRef = useRef(getLang())
  const forceUpdate = useForceUpdate()

  useSyncEvent(
    'profile',
    {
      debounceTime: 50,
      filter: globals.currentUserId
    },
    () => {
      const newLang = getLang()

      if (prevRef.current !== newLang) {
        prevRef.current = newLang

        forceUpdate()
      }
    }
  )

  return prevRef.current
}

const getLang = (): Language => {
  const user = Sync.getCurrentUser()
  return user.language
}
